import React from 'react'
import AddPropertyLandlord from '../Components/Property/AddPropertyLandlord'
const AddProperty = () => {
  return (
    <AddPropertyLandlord />
  )
}
export default AddProperty